import React from 'react';
import PropTypes from 'prop-types';
import { fade, withStyles } from '@material-ui/core/styles';
import conditionalFormats from "../../store/conditionalFormats";
import { formatFloat } from '../../utils';
import { statGrey, statGreen, athenaGreen, statOrange, statRed } from '../../globals';


const styles = theme => ({
  green: {
    color: athenaGreen,
  },
  orange: {
    color: statOrange,
  },
  red: {
    color: statRed,
  },
  grey: {
    color: statGrey,
  },
  rect: {
    display: 'block',
    padding: theme.spacing(0.5, 1),
    borderRadius: 5,
    fontWeight: 900,
    color: statGrey,
    backgroundColor: fade(statGrey, 0.2),
    textAlign: 'center',
  },
  greenRect: {
    color: statGreen,
    backgroundColor: fade(statGreen, 0.2),
  },
  orangeRect: {
    color: statOrange,
    backgroundColor: fade(statOrange, 0.2),
  },
  redRect: {
    color: statRed,
    backgroundColor: fade(statRed, 0.2),
  },
});


@withStyles(styles)
class ConditionalFormat extends React.Component {
  static propTypes = {
    value: PropTypes.any,
    name: PropTypes.string,
    children: PropTypes.any,
    variant: PropTypes.oneOf(['text', 'rect']),
  };

  static defaultProps = {
    value: null,
    name: null,
    children: null,
    variant: 'text',
  };

  get colorClassName() {
    const { name, value } = this.props;
    if (name in conditionalFormats) {
      return conditionalFormats[name].getColorName(value);
    }
    return 'grey';
  }

  get classes() {
    const { variant, classes } = this.props;
    let colorClassName = this.colorClassName;
    const classNames = [];
    if (variant === 'rect') {
      classNames.push(classes.rect);
    }
    if (colorClassName) {
      if (variant === 'rect') {
        colorClassName += 'Rect';
      }
      classNames.push(classes[colorClassName]);
    }
    return classNames;
  }

  render() {
    const { children, value } = this.props;
    const content = children ? children : formatFloat(value);
    return (
      <span className={this.classes.join(' ')}>{content}</span>
    );
  }
}


export default ConditionalFormat;
